import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { getI18N } from '../../i18N';
import './style.scss';

const ViewAllEvents = ({ onViewAllEventsClick }) => {
  const { t } = getI18N();

  return (
    <div className="viewAllEventsContainer">
      <div className="viewAllEventsTextContainer">
        <Typography className="viewAllEventsTextHeading">
          {t('view_all_events_that_will_be_triggered')}
        </Typography>
        <Typography className="viewAllEventsTextSubheading">
          {t('view_all_events_that_will_be_triggered_subheading')}
        </Typography>
      </div>
      <Button variant="contained" onClick={onViewAllEventsClick} className="viewAllEventsButton">
        {t('view_all_events')}
      </Button>
    </div>
  );
};

export default ViewAllEvents;
